import { createSelector } from "reselect"
import { pick } from "lodash"
import { getSelectedBase } from "modules/portfolio-root/selectors/base"
import { getCurrentPortfolio, getIsActive } from "modules/portfolio-root/selectors/portfolios"

export const getContextBase = createSelector(
  [getSelectedBase, getIsActive],
  (selectedBase, isActive) => {
    if (isActive) {
      return pick(selectedBase, ["type", "id", "experimentId"])
    }

    return null
  },
)

// Built on the guarded getCurrentPortfolio so a stale previous portfolio reads as null
export const getPagePortfolio = createSelector(
  [getCurrentPortfolio],
  (currentPortfolio) => (currentPortfolio ? pick(currentPortfolio, ["id", "alias"]) : null),
)
